// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { SvgContainer } from 'common/styles/oc-styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Component
const SpeedyResponderSvg = ({ height, margin, width }) => (
  <SvgContainer
    color={colors.blue}
    height={height}
    margin={margin}
    width={width}
  >
    <svg
      width="11px"
      height="18px"
      viewBox="0 0 11 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
    >
      <g
        id="Search_Results"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Practice-Badges-Profile"
          transform="translate(-41.000000, -1303.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="SpeedyResponder" transform="translate(25.000000, 1293.000000)">
            <polygon
              id=""
              points="19.09375 28 26.59375 17.5 22.09375 17.5 23.5 10 16 20.5 20.5 20.5"
            />
          </g>
        </g>
      </g>
    </svg>
  </SvgContainer>
);

SpeedyResponderSvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default SpeedyResponderSvg;
